const loadSearchableRoutes = ({ commit }, payload) => {
    commit('LOAD_SEARCHABLE_ROUTES', payload);
};

export default {
    loadSearchableRoutes,
};
